import type { Xinglet } from '@xing-com/crate-xinglet';

import { Article } from './article';

export default class ArticleXinglet implements Xinglet {
  public getComponent() {
    return (): JSX.Element => <Article />;
  }
}
